module.exports = __webpack_public_path__ + "static/media/oxford.795bbfce.webp";